import { combineReducers, configureStore } from '@reduxjs/toolkit'

import { authReducer } from './reducers/auth/authSlice'
import { adminsReducer } from './reducers/admins/adminsSlice'
import { companiesReducer } from './reducers/companies/companiesSlice'
import { daDataReducer } from './reducers/daData/daDataSlice'
import { staffReducer } from './reducers/staff/staffSlice'
import { placesReducer } from './reducers/places/placesSlice'
import { claimsReducer } from './reducers/claims/claimsSlice'
import { registrationRequestReducer } from './reducers/registrationRequest/registrationRequestSlice'
import { meReducer } from './reducers/me/meSlice'
import { establishmentsReducer } from './reducers/establishments/establishmentsSlice'
import { menuReducer } from './reducers/menu/menuSlice'
import { categoriesReducer } from './reducers/categories/categoriesSlice'
import { productsReducer } from './reducers/products/productsSlice'
import { orderReducer } from './reducers/orders/ordersSlice'
import { publicOrderReducer } from './reducers/publicOrder/publicOrderSlice'
import { clientReducer } from './reducers/clients/clientsSlice'
import { managerReducer } from './reducers/managers/managersSlice'
import { notificationsReducer } from './reducers/notifications/notificationsSlice'
import bookingTabsReducer from './reducers/bookingTabs/bookingTabsReducer'
import { templatesReducer } from './reducers/templates/templatesSlice'
import { servicesReducer } from './reducers/services/servicesSlice'
import { strReducer } from './reducers/str/strSlice'

export const rootReducer = combineReducers({
  auth: authReducer,
  admins: adminsReducer,
  companies: companiesReducer,
  daData: daDataReducer,
  staff: staffReducer,
  places: placesReducer,
  claims: claimsReducer,
  registrationRequest: registrationRequestReducer,
  me: meReducer,
  establishments: establishmentsReducer,
  categories: categoriesReducer,
  menu: menuReducer,
  products: productsReducer,
  orders: orderReducer,
  publicOrder: publicOrderReducer,
  clients: clientReducer,
  managers: managerReducer,
  notifications: notificationsReducer,
  bookingTabs: bookingTabsReducer,
  templates: templatesReducer,
  services: servicesReducer,
  str: strReducer,
})

export const store = configureStore({
  reducer: rootReducer,
})

export type RootState = ReturnType<typeof store.getState>

// @ts-ignore
window.store = store
